module.exports = __webpack_public_path__ + "img/social_media_default.8a92fde5.png";